import { Component } from '@angular/core';
import { httpService } from './components/body.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  nombre:string = "Soy el nombre";
  apellido:string = "y yo el apellido";
  
  constructor (public http: httpService) {};

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/app.component.ts